import type { ReactNode } from "react";
import { cn } from "./cn";

export interface DetailItem {
  label: string;
  value: ReactNode;
}

export function DetailList({
  items,
  columns = 2,
  className
}: {
  items: DetailItem[];
  columns?: 1 | 2 | 3;
  className?: string;
}) {
  const columnClass = {
    1: "grid-cols-1",
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
  }[columns];

  return (
    <dl className={cn("grid gap-x-6 gap-y-5 text-left", columnClass, className)}>
      {items.map((item) => (
        <div key={item.label} className="min-w-0">
          <dt className="text-xs text-muted-foreground">
            {item.label}
          </dt>
          <dd className="mt-1 break-words text-sm font-medium text-zinc-900 dark:text-zinc-100">
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
